module.exports = __webpack_public_path__ + "static/media/katarina.2efd1450.png";